import { render, staticRenderFns } from "./tableQuestion.vue?vue&type=template&id=43da7964&lang=pug"
import script from "./tableQuestion.vue?vue&type=script&lang=js"
export * from "./tableQuestion.vue?vue&type=script&lang=js"
import style0 from "./tableQuestion.vue?vue&type=style&index=0&id=43da7964&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports